
import '../styles/Footer.css';
import facebookLogo from '../../../icons/facebook.png';
import emailLogo from '../../../icons/email.png';

const Footer = () => {
    const phone = "04936-215339";
    const email = "edakkaldmc@dtpcwayanad.com";
    const web = "www.dtpcwayanad.com";

    function link(type, i) {
        if (type === "phone") {
            return `tel:${i}`.replace(/ /g, "");
        } else if (type === "email") {
            return "mailto:" + i;
        }
        return "http://" + i;
    }

    return (
        <div className="footer">
            <img src={facebookLogo} alt="Facebook" />
            <img src={emailLogo} alt="Email" />
            <p>Edakkal Destination Management Council, Ambalavayal</p>
            <p>Phone: <a href={link("phone", phone)}>{phone}</a>, E-mail:  <a href={link("email", email)}>{email}</a> .</p>
            <p>Website: <a href={link("web", web)}>{web}</a></p>
            <p>All rights reserved © Kerala Tourism {new Date().getFullYear()}</p>
            <p>Developed & Maintained by BitSmart</p>
        </div>
    );
}

export default Footer;